import { render, staticRenderFns } from "./FormTypeSelector.vue?vue&type=template&id=2fe36dac&scoped=true"
import script from "./FormTypeSelector.vue?vue&type=script&lang=js"
export * from "./FormTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./FormTypeSelector.vue?vue&type=style&index=0&id=2fe36dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe36dac",
  null
  
)

export default component.exports